import { type SVGProps } from "react"
import { IconBase } from "./IconBase"

export function BatteriePrimusIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props} viewBox="0 0 200 135">
      <path d="M30 5h35v20H30zM135 5h35v20h-35z" />
      <path
        fill="none"
        stroke="currentColor"
        stroke-width="10"
        d="M10 25h180v100H10z"
      />
      <path d="M35 70h40v10H35zM125 70h40v10h-40z" />
      <path d="M140 55h10v40h-10z" />
    </IconBase>
  )
}
